import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "configpair"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  class: "pi pi-copy copy-icon",
  "data-testid": "copy-icon"
}
const _hoisted_4 = {
  class: "pi pi-copy copy-icon",
  "data-testid": "copy-icon"
}
const _hoisted_5 = {
  key: 1,
  class: "configpair"
}
const _hoisted_6 = ["title"]
const _hoisted_7 = {
  style: {"font-family":"Courier, monospace"},
  "data-testid": "integer-prop-value"
}
const _hoisted_8 = {
  key: 2,
  class: "configpair"
}
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  class: "pi pi-copy copy-icon",
  "data-testid": "copy-icon"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "glyphicon glyphicon-ok-circle" }
const _hoisted_14 = {
  class: "pi pi-copy copy-icon",
  "data-testid": "copy-icon"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "glyphicon glyphicon-ok-circle" }
const _hoisted_18 = {
  class: "pi pi-copy copy-icon",
  "data-testid": "copy-icon"
}
const _hoisted_19 = {
  key: 3,
  class: "configpair"
}
const _hoisted_20 = ["title"]
const _hoisted_21 = {
  "data-testid": "code-line-count",
  class: "text-info"
}
const _hoisted_22 = ["title"]
const _hoisted_23 = {
  "data-testid": "multiline-line-count",
  class: "text-info"
}
const _hoisted_24 = { title: "" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  class: "pi pi-copy copy-icon",
  "data-testid": "copy-icon"
}
const _hoisted_27 = {
  key: 3,
  class: ""
}
const _hoisted_28 = ["title"]
const _hoisted_29 = ["title"]
const _hoisted_30 = {
  class: "pi pi-copy copy-icon",
  "data-testid": "copy-icon"
}
const _hoisted_31 = {
  class: "pi pi-copy copy-icon",
  "data-testid": "copy-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_plugin_prop_val = _resolveComponent("plugin-prop-val")!
  const _component_ace_editor = _resolveComponent("ace-editor")!
  const _component_expandable = _resolveComponent("expandable")!

  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.prop.type === 'Boolean')
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          (
          _ctx.innerValue === 'true' ||
          (_ctx.prop.defaultValue === 'true' && _ctx.innerValue === 'false')
        )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", {
                  "data-testid": "boolean-prop-title",
                  title: _ctx.prop.desc ? _ctx.$t(_ctx.prop.desc) : ''
                }, _toDisplayString(_ctx.$t(_ctx.prop.title)) + ": ", 9, _hoisted_2),
                (_ctx.innerValue === 'true')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      "data-testid": "boolean-true-value",
                      class: _normalizeClass([
            (_ctx.prop.options && _ctx.prop.options['booleanTrueDisplayValueClass']) ||
              'text-success',
            'copiable-text',
          ]),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyText(_ctx.innerValue)))
                    }, [
                      _createVNode(_component_plugin_prop_val, {
                        prop: _ctx.prop,
                        value: _ctx.innerValue
                      }, null, 8, ["prop", "value"]),
                      _withDirectives(_createElementVNode("i", _hoisted_3, null, 512), [
                        [_vShow, _ctx.allowCopy]
                      ])
                    ], 2))
                  : (_ctx.innerValue === 'false')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        "data-testid": "boolean-false-value",
                        class: _normalizeClass([
            (_ctx.prop.options && _ctx.prop.options['booleanFalseDisplayValueClass']) ||
              'text-success',
            'copiable-text',
          ]),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyText(_ctx.innerValue)))
                      }, [
                        _createVNode(_component_plugin_prop_val, {
                          prop: _ctx.prop,
                          value: _ctx.innerValue
                        }, null, 8, ["prop", "value"]),
                        _withDirectives(_createElementVNode("i", _hoisted_4, null, 512), [
                          [_vShow, _ctx.allowCopy]
                        ])
                      ], 2))
                    : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
        ]))
      : (_ctx.prop.type === 'Integer')
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _createElementVNode("span", {
              title: _ctx.prop.desc ? _ctx.$t(_ctx.prop.desc) : '',
              "data-testid": "integer-prop-title"
            }, _toDisplayString(_ctx.$t(_ctx.prop.title)) + ": ", 9, _hoisted_6),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.innerValue), 1)
          ]))
        : (['Options', 'Select', 'FreeSelect'].indexOf(_ctx.prop.type) >= 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
              _createElementVNode("span", null, [
                _createElementVNode("span", {
                  "data-testid": "options-prop-title",
                  title: _ctx.prop.desc ? _ctx.$t(_ctx.prop.desc) : ''
                }, _toDisplayString(_ctx.$t(_ctx.prop.title)) + ":", 9, _hoisted_9),
                (_ctx.prop.type !== 'Options')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "text-success copiable-text",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyText(_ctx.innerValue)))
                    }, [
                      _createVNode(_component_plugin_prop_val, {
                        prop: _ctx.prop,
                        value: _ctx.innerValue
                      }, null, 8, ["prop", "value"]),
                      _withDirectives(_createElementVNode("i", _hoisted_10, null, 512), [
                        [_vShow, _ctx.allowCopy]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (typeof _ctx.value === 'string')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.innerValue.split(/, */), (optval) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: optval,
                                "data-testid": "option-value",
                                class: "text-success copiable-text",
                                onClick: ($event: any) => (_ctx.copyText(optval))
                              }, [
                                _withDirectives(_createElementVNode("i", _hoisted_13, null, 512), [
                                  [_vShow, !(_ctx.prop.options && _ctx.prop.options['valueDisplayType'])]
                                ]),
                                _createVNode(_component_plugin_prop_val, {
                                  prop: _ctx.prop,
                                  value: optval
                                }, null, 8, ["prop", "value"]),
                                _withDirectives(_createElementVNode("i", _hoisted_14, null, 512), [
                                  [_vShow, _ctx.allowCopy]
                                ])
                              ], 8, _hoisted_12))
                            }), 128))
                          ]))
                        : (typeof _ctx.value !== 'string' && _ctx.innerValue.length > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.innerValue, (optval) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: optval,
                                  class: "text-success copiable-text",
                                  onClick: ($event: any) => (_ctx.copyText(optval))
                                }, [
                                  _withDirectives(_createElementVNode("i", _hoisted_17, null, 512), [
                                    [_vShow, !(_ctx.prop.options && _ctx.prop.options['valueDisplayType'])]
                                  ]),
                                  _createVNode(_component_plugin_prop_val, {
                                    prop: _ctx.prop,
                                    value: optval
                                  }, null, 8, ["prop", "value"]),
                                  _withDirectives(_createElementVNode("i", _hoisted_18, null, 512), [
                                    [_vShow, _ctx.allowCopy]
                                  ])
                                ], 8, _hoisted_16))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [], 64))
                    ], 64))
              ])
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_19, [
              (_ctx.prop.options && _ctx.prop.options['displayType'] === 'CODE')
                ? (_openBlock(), _createBlock(_component_expandable, { key: 0 }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", {
                        "data-testid": "code-prop-title",
                        title: _ctx.prop.desc ? _ctx.$t(_ctx.prop.desc) : ''
                      }, _toDisplayString(_ctx.$t(_ctx.prop.title)) + ":", 9, _hoisted_20),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.innerValue.split(/\r?\n/).length) + " lines ", 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_ace_editor, {
                        modelValue: _ctx.innerValue,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.innerValue) = $event)),
                        lang: _ctx.prop.options['codeSyntaxMode'],
                        height: "200",
                        width: "100%",
                        "read-only": true,
                        "min-lines": 12,
                        "max-lines": Infinity
                      }, null, 8, ["modelValue", "lang"])
                    ]),
                    _: 1
                  }))
                : (_ctx.prop.options && _ctx.prop.options['displayType'] === 'MULTI_LINE')
                  ? (_openBlock(), _createBlock(_component_expandable, { key: 1 }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", {
                          "data-testid": "multiline-prop-title",
                          title: _ctx.prop.desc ? _ctx.$t(_ctx.prop.desc) : ''
                        }, _toDisplayString(_ctx.$t(_ctx.prop.title)) + ":", 9, _hoisted_22),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(`${_ctx.innerValue}`.split(/\r?\n/).length) + " lines", 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_ace_editor, {
                          modelValue: _ctx.innerValue,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.innerValue) = $event)),
                          height: "200",
                          width: "100%",
                          "read-only": true,
                          "min-lines": 12,
                          "max-lines": Infinity
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : (
          _ctx.prop.options && _ctx.prop.options['displayType'] === 'DYNAMIC_FORM'
        )
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "customattributes" }, null, -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCustomValues(), (custom, index) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: `customValueForConfigPair${index}`,
                            class: "configpair",
                            "data-testid": "configpair"
                          }, [
                            _createElementVNode("span", _hoisted_24, _toDisplayString(String(custom.label ?? "").trim() || custom.key) + ":", 1),
                            _createElementVNode("span", {
                              class: "text-success copiable-text",
                              onClick: ($event: any) => (_ctx.copyText(custom.value))
                            }, [
                              _createTextVNode(_toDisplayString(custom.value) + " ", 1),
                              _withDirectives(_createElementVNode("i", _hoisted_26, null, 512), [
                                [_vShow, _ctx.allowCopy]
                              ])
                            ], 8, _hoisted_25)
                          ]))
                        }), 128))
                      ], 64))
                    : (_openBlock(), _createElementBlock("span", _hoisted_27, [
                        _createElementVNode("span", {
                          "data-testid": "string-prop-title",
                          title: _ctx.prop.desc ? _ctx.$t(_ctx.prop.desc) : ''
                        }, _toDisplayString(_ctx.$t(_ctx.prop.title)) + ":", 9, _hoisted_28),
                        (_ctx.prop.options && _ctx.prop.options['displayType'] === 'PASSWORD')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              "data-testid": "password-prop-value",
                              class: "text-success copiable-text",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.copyText(_ctx.innerValue))),
                              title: _ctx.allowCopy ? 'Click to copy password' : ''
                            }, [
                              _cache[8] || (_cache[8] = _createTextVNode(" •••••••••••• ", -1)),
                              _withDirectives(_createElementVNode("i", _hoisted_30, null, 512), [
                                [_vShow, _ctx.allowCopy]
                              ])
                            ], 8, _hoisted_29))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              "data-testid": "string-prop-value",
                              class: "text-success copiable-text",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.copyText(_ctx.innerValue)))
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.innerValue) + " ", 1),
                              _withDirectives(_createElementVNode("i", _hoisted_31, null, 512), [
                                [_vShow, _ctx.allowCopy]
                              ])
                            ]))
                      ]))
            ]))
  ]))
}